import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../service/api.service';
import {AccountService} from "../service/account.service";
import {DealService} from "../service/deal.service";
import {Deal} from "../model/deal.model";
import {ModalComponent} from "../modal/modal.component";
import {FolderService} from "../service/folder.service";
import {indexNotFound, isDefined, isEmpty, isString, utf8Decode} from "sdv-common";
import {Attribute} from "../model/attribute.model";
import {NetworkService} from "../service/network.service";
import {ExchangeService} from "../service/exchange.service";

@Component({
  selector: 'deal',
  templateUrl: './deal.component.html',
  styleUrls: ['./deal.component.scss']
})
export class DealComponent implements OnInit {

  @ViewChild('rd') removeDeal: ModalComponent;
  @ViewChild('ed') editDeal: ModalComponent;
  @ViewChild('od') outDeal: ModalComponent;
  mode = 'none'; // none | add | edit

  cur = {
    direction: 'LONG',
    created: new Date(),
    account: '',
    folder: '',
    fromToken: '',
    fromAddress: '',
    tokens: [],
    toToken: '',
    toAddress: '',
    quantity: 0,
    price: 0,
    sum: 0,
    tags: '',
    comment: '',
    inOrder: false
  };
  import = {
    address: '',
    definition: 'n1' // n - network (chain), e - exchange
  };
  sell = {
    orderType: 'TAKE_PROFIT',
    sellQuantity: 0,
    sellPrice: 0
  };
  deal: Deal;
  error = '';
  loading = false;
  submitted = false;
  searchTokenInterval = 0; // needed to delay on 1sec to determinate finish typing (interval object)

  constructor(public apiService: ApiService,
              public dealService: DealService,
              public networkService: NetworkService,
              public exchangeService: ExchangeService,
              public folderService: FolderService,
              public accountService: AccountService) {
  }

  ngOnInit() {
    if (this.apiService.getParam('$action') === 'edit-deal') {
      const dealId = this.apiService.getParam('$deal');
      let l = () => {
        const groups = this.dealService.getGroups();
        for (const group of groups) {
          for (const deal of group.deals) {
            if (deal.id === dealId) {
              group.expandGroup = true;
              deal.selected = true;
              this.setDeal('edit', deal);
              return;
            }
          }
        }
        if (groups.length === 0) {
          setTimeout(l, 1000);
        }
      };
      l();
    }
  }

  setDeal(mode, deal = null) {
    this.mode = mode;
    this.deal = deal;
    if (!isDefined(deal)) {
      return;
    }
    if (deal.price && deal.quantity) {
      this.cur.sum = deal.price * deal.quantity;
    }
    this.cur.created = new Date(deal.created);
    this.cur.direction = deal.direction;
    this.cur.account = deal.account_id;
    this.cur.folder = deal.folder_id;
    this.cur.fromToken = deal.fromToken.symbol;
    this.cur.fromAddress = deal.fromToken.contract;
    this.cur.toToken = deal.toToken.symbol;
    this.cur.toAddress = deal.toToken.contract;
    this.cur.quantity = deal.quantity;
    this.cur.price = deal.price;
    this.cur.tags = deal.attributes
      .filter(n => n.code === this.dealService.tagAttrId)
      .map(n => n.value)
      .join(' ');
    this.cur.comment = deal.attributes
      .filter(n => n.code === this.dealService.commentAttrId)
      .map(n => n.value)
      .join();
  }

  isValidData() {
    if (isEmpty(this.cur.fromAddress)) {
      return false;
    }
    if (isEmpty(this.cur.toAddress)) {
      return false;
    }
    if (this.cur.price <= 0) {
      return false;
    }
    if (this.cur.quantity <= 0) {
      return false;
    }
    if (this.cur.account === '') {
      return false;
    }
    return true;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.isValidData()) {
      return;
    }
    this.loading = true;
    if (this.apiService.getParam('$action') === 'add-deal'
      || this.cur.quantity >= this.deal.quantity
      || this.getAttributeValue(this.deal.attributes, this.dealService.inOrderAttrId, false)) {
      this.applyDealChanges();
      return;
    }
    this.editDeal.open();
  }

  applyDealChanges() {
    this.editDeal.submitted = true;

    let _this = this;
    if (isString(this.cur.created)) {
      this.cur.created = new Date(this.cur.created);
    }
    let request = {
      created: this.cur.created.getTime(),
      direction: this.cur.direction,
      accountId: this.cur.account,
      folderId: this.cur.folder,
      quantity: this.cur.quantity,
      fromToken: {
        address: this.cur.fromAddress
      },
      toToken: {
        address: this.cur.toAddress
      },
      price: (this.cur.price + '').replace(',', '.'),
      sellPrice: (this.sell.sellPrice + '').replace(',', '.'),
      attributes: []
    };
    if (this.cur.inOrder) {
      request.attributes.push({
        typeId: this.dealService.inOrderAttrId,
        value: true
      });
    }
    if (!isEmpty(this.cur.comment)) {
      request.attributes.push({
        typeId: this.dealService.commentAttrId,
        value: this.cur.comment
      });
    }
    if (!isEmpty(this.cur.tags)) {
      const tags = this.cur.tags.split(' ');
      for (const tag of tags) {
        request.attributes.push({
          typeId: this.dealService.tagAttrId,
          value: tag
        });
      }
    }

    if (this.apiService.getParam('$action') === 'add-deal') {
      this.dealService.add(request)
        .then((dealId) => {
          this.apiService.setParams({
            '$action': 'edit-deal',
            '$deal': dealId
          });
          _this.loading = false;
        })
        .catch(err => {
          _this.error = err.message;
          _this.loading = false;
        });
    } else if (this.apiService.getParam('$action') === 'edit-deal') {
      this.dealService.edit(this.deal.id, request)
        .then(() => {
          _this.loading = false;
        })
        .catch(err => {
          _this.error = err.message;
          _this.loading = false;
        });
    } else {
      debugger;
    }
  }

  remove(dealId) {
    this.setDeal('none', null);
    const deal = Array.prototype.concat.apply([], this.dealService.getGroups().map(g => g.deals))
      .find(d => d.id === dealId);
    if (!isDefined(deal)) {
      return;
    }
    if (this.getAttributeValue(deal.attributes, this.dealService.inOrderAttrId, false)) {
      this.deleteDeal(dealId);
    } else {
      this.removeDeal.open(dealId);
    }
  }

  deleteDeal(dealId?) {
    this.removeDeal.submitted = true;
    if (!isDefined(dealId)) {
      dealId = this.removeDeal.get();
    }
    this.dealService.remove(dealId, (this.sell.sellPrice + '').replace(',', '.'))
      .then(() => {
        this.removeDeal.close();
      })
      .catch(err => {
        this.apiService.error({}, err);
      });
  }

  attrCreate(deal, attrId, value) {
    this.apiService.post('deals/' + deal.id + '/attributes', {
      typeId: attrId,
      value
    })
      .subscribe(response => {
        deal.attributes.push({
          created: response.createdMillis,
          id: utf8Decode(response.id),
          value: response.value,
          code: response.code
        });
      }, err => {
        this.apiService.error({}, err);
      });
  }

  attrDelete(deal, attrId) {
    return new Promise((resolve, reject) => {
      this.apiService.delete('deals/' + deal.id + '/attributes/' + attrId)
        .subscribe(() => {
          let dealIndex = indexNotFound;
          for (let i = 0; i < deal.attributes.length; i++) {
            if (deal.attributes[i].id === attrId) {
              dealIndex = i;
              break;
            }
          }
          if (dealIndex != indexNotFound) {
            deal.attributes.splice(dealIndex, 1);
          }
          resolve({});
        }, err => {
          this.apiService.error({}, err);
          reject(err);
        });
    });
  }

  calcPrice() {
    this.cur.price = this.cur.sum / this.cur.quantity;
  }

  calcSum() {
    this.cur.sum = this.cur.quantity * this.cur.price;
  }

  applyOutDeal() {
    this.outDeal.submitted = true;

    const _this = this;
    this.apiService.post('deals/' + this.deal.id + '/attributes', {
      typeId: this.dealService.outOrderAttrId,
      value: JSON.stringify({
        quantity: (this.sell.sellQuantity + '').replace(',', '.'),
        price: (this.sell.sellPrice + '').replace(',', '.'),
        type: this.sell.orderType
      })
    })
      .subscribe(res => {
        this.outDeal.close();
        _this.loading = false;
      }, err => {
        this.apiService.error({}, err);
        _this.loading = false;
      });
  }

  balance() {
    this.sell.sellQuantity = this.deal.quantity;
  }

  importToken($e) {
    let networkId = 0;
    let exchangeId = 0;
    if (this.import.definition.startsWith('n')) {
      networkId = parseInt(this.import.definition.substring(1));
    } else if (this.import.definition.startsWith('e')) {
      exchangeId = parseInt(this.import.definition.substring(1));
    } else {
      debugger;
    }

    this.apiService.get('tokens/search', {
      '$value': this.import.address,
      '$exchange_id': exchangeId,
      '$network_id': networkId,
      '$more': true
    })
      .subscribe(res => {
        $e.target.parentNode.querySelector('[data-bs-dismiss]')
          .dispatchEvent(new Event('click'));
      }, err => {
        this.apiService.error({}, err);
      });
  }

  findToken(val) {
    clearTimeout(this.searchTokenInterval);
    this.cur.tokens.splice(0, this.cur.tokens.length);

    this.searchTokenInterval = setTimeout(() => {
      if (isEmpty(val)) {
        return;
      }
      this.apiService.get('tokens/search', {
        '$value': val,
        '$more': false
      })
        .subscribe(response => {
          for (const resp of response) {
            this.cur.tokens.push({
              name: resp.name,
              icon: resp.icon,
              symbol: resp.symbol,
              address: resp.contract
            });
          }
        }, err => {
          this.apiService.error({}, err);
        });
    }, 1000);
  }

  getAttribute(attributes: Attribute[], search) {
    return attributes.find(n => n.code === search);
  }

  getAttributeValue(attributes: Attribute[], search, def: any = undefined) {
    const attribute = this.getAttribute(attributes, search);
    return isDefined(attribute) ? attribute.value : def;
  }

  protected readonly isEmpty = isEmpty;
}
